import { AutoComplete } from '@baseComponents';

interface StateAgencySelectProps {
  states: string[];
  agencies: string[];
  agenciesLoading: boolean;
  state: string;
  agencyName: string;
  onStateChange: (state: string) => void;
  onAgencyChange: (agencyName: string) => void;
}

const StateAgencySelect = ({
  states,
  agencies,
  agenciesLoading,
  state,
  agencyName,
  onStateChange,
  onAgencyChange,
}: StateAgencySelectProps) => {
  return (
    <>
      <AutoComplete
        id='state'
        label='State'
        options={states}
        value={state}
        onChange={(_, value) => onStateChange(value ?? '')}
        required
        style={{ marginTop: '16px' }}
      />
      <AutoComplete
        id='agency'
        label='Law Enforcement Agency'
        options={agencies}
        value={agencyName}
        onChange={(_, value) => onAgencyChange(value ?? '')}
        required
        disabled={!state}
        loading={agenciesLoading}
        style={{ marginTop: '16px' }}
      />
    </>
  );
};

export default StateAgencySelect;
